// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"segmentContent_mulitpleDropdown__1LH8T","container":"segmentContent_container___xRn6"};